export const locales = ["en", "fr", "es", "pt"];

const dictionary = {
  "en": {
    "lang_label": "Language",
    "app_name": "flytrap",
    "app_subtitle": "Webhook catcher for debugging",
    "menu": "Menu",
    "open_menu": "Open menu",
    "close_menu": "Close menu",
    "connected": "Connected",
    "disconnected": "Disconnected",
    "pause_polling": "Pause polling",
    "resume_polling": "Resume polling",
    "refresh": "Refresh",
    "nav_live": "Live",
    "nav_history": "History",
    "nav_settings": "Settings",
    "nav_runtime": "Runtime",
    "logout": "Logout",
    "api_key": "API Key",
    "login_subtitle": "Webhook catcher for debugging",
    "login_enter_key": "Enter your API key",
    "login_api_key_required": "API key is required",
    "auth_required": "Authentication required",
    "login_invalid_key": "Invalid API key",
    "login_server_error": "Server error: {status}",
    "login_connection_failed": "Connection failed",
    "login_authenticating": "Authenticating...",
    "login_button": "Continue",
    "loading": "Loading...",
    "save": "Save",
    "optional": "Optional",
    "enabled": "Enabled",
    "disabled": "Disabled",
    "status": "Status",
    "connection": "Connection",
    "auth": "Auth",
    "default": "default",
    "items_count": "{count} items",
    "history_title": "History",
    "history_subtitle": "Browse and inspect captured webhooks",
    "history_refresh": "Refresh",
    "history_refresh_title": "Refresh list",
    "history_search_placeholder": "Search path... (Enter)",
    "history_total": "{count} total",
    "history_sort_time": "Sort by time",
    "history_sort_time_latest": "Latest first (click for oldest first)",
    "history_sort_path": "Sort by path",
    "history_sort_path_asc": "A-Z (click for Z-A)",
    "history_sort_path_desc": "Z-A (click for A-Z)",
    "history_empty": "No webhooks received yet",
    "history_rejected": "Rejected",
    "history_rejected_title": "Rejected with HTTP {status}",
    "history_signature": "Sig",
    "history_signature_title": "Signature included",
    "history_from": "From {ip} · {size} bytes",
    "history_showing": "Showing {start} - {end} of {total}",
    "history_detail": "Webhook detail",
    "close": "Close",
    "live_title": "Live",
    "live_subtitle": "Latest webhook and headers (updates every 1s)",
    "live_paused": "Paused",
    "live_send_to": "Send webhooks to:",
    "live_empty": "No webhook received yet",
    "live_show_more": "Show more",
    "live_show_less": "Show less",
    "live_waiting_title": "Waiting for webhooks...",
    "live_waiting_body": "Send a POST/PUT/PATCH/DELETE request to any path on this server",
    "live_received": "Received: {timestamp}",
    "live_from": "From: {ip}",
    "live_origin": "Origin:",
    "live_bytes": "{size} bytes",
    "live_multipart": "File upload (multipart) received - {size} bytes. Raw body below.",
    "runtime_title": "Runtime",
    "runtime_subtitle": "Live log tail (refreshes every 1s)",
    "runtime_limit": "limit: {limit}",
    "runtime_updated": "updated: {time}",
    "runtime_refresh_title": "Refresh now",
    "runtime_pause_title": "Pause polling",
    "runtime_resume_title": "Resume polling",
    "runtime_pause": "Pause",
    "runtime_search": "Search",
    "runtime_search_placeholder": "contains...",
    "runtime_search_hint": "Case-insensitive contains match.",
    "runtime_limit_label": "Limit",
    "runtime_limit_hint": "Client-side cap (max 100).",
    "runtime_error_title": "Runtime tail error",
    "runtime_last_lines": "Last {limit} lines",
    "runtime_shown": "{count} shown",
    "runtime_no_lines": "No lines.",
    "settings_title": "Settings",
    "settings_subtitle": "How this instance is configured",
    "settings_signature_title": "Signature verification",
    "settings_signature_hint": "Stored in Redis. Signature type is read first; backend uses it to verify the secret. Result stored per webhook (validated).",
    "settings_signature_header": "Signature header (type)",
    "settings_secret_value": "Secret value",
    "settings_rejection_title": "Rejection (always fail)",
    "settings_rejection_hint": "When on, all incoming webhooks are rejected. Stored in Redis so you can toggle in real time (e.g. with a loop of webhooks running).",
    "settings_reject_all": "Reject all webhooks",
    "settings_status_code": "Status code",
    "reject_random": "Random - random error each time",
    "reject_cors": "simulate CORS error",
    "http_400": "Bad Request",
    "http_401": "Unauthorized",
    "http_403": "Forbidden",
    "http_404": "simulate non-existent URL",
    "http_405": "Method Not Allowed",
    "http_408": "Request Timeout",
    "http_409": "Conflict",
    "http_410": "Gone",
    "http_412": "Precondition Failed",
    "http_422": "Unprocessable Entity",
    "http_429": "Too Many Requests",
    "http_500": "Internal Server Error",
    "http_502": "Bad Gateway",
    "http_503": "simulate maintenance mode",
    "http_504": "Gateway Timeout",
    "webhook_timestamp": "Timestamp",
    "webhook_source_ip": "Source IP",
    "webhook_size": "Size",
    "webhook_user_agent": "User Agent",
    "webhook_na": "N/A",
    "webhook_origin": "Origin",
    "webhook_response": "Response",
    "webhook_rejected_with": "Rejected with HTTP {status}",
    "webhook_config_at_process": "Config at process time",
    "webhook_reject": "Reject:",
    "webhook_signing": "Signing:",
    "webhook_header": "header",
    "webhook_secret": "secret:",
    "webhook_on": "on ({status})",
    "webhook_off": "off",
    "webhook_not_set_off": "not set (off)",
    "webhook_not_set": "not set",
    "webhook_signature": "Signature",
    "webhook_no_signature": "No signature received",
    "webhook_signing_not_configured": "Signing not configured - set a secret in Settings to verify signatures",
    "webhook_signature_valid": "Signature valid",
    "webhook_signature_invalid": "Signature invalid",
    "webhook_id": "ID",
    "login_acdev_headline": "ship faster with baseblox",
    "login_acdev_description": "baseblox is a suite of microservices ready to drop into your infrastructure which reduces the time to build complex applications and the costs of platforms like AWS.",
    "login_acdev_link": "acdevservices.com",
    "login_acdev_licensing": "licensing & support",
    "login_acdev_contact": "support@acdevservices.com"
  },
  "fr": {
    "lang_label": "Langue",
    "app_name": "flytrap",
    "app_subtitle": "Collecteur de webhooks pour le débogage",
    "menu": "Menu",
    "open_menu": "Ouvrir le menu",
    "close_menu": "Fermer le menu",
    "connected": "Connecté",
    "disconnected": "Déconnecté",
    "pause_polling": "Mettre en pause",
    "resume_polling": "Reprendre",
    "refresh": "Rafraîchir",
    "nav_live": "Direct",
    "nav_history": "Historique",
    "nav_settings": "Paramètres",
    "nav_runtime": "Runtime",
    "logout": "Déconnexion",
    "api_key": "Clé API",
    "login_subtitle": "Collecteur de webhooks pour le débogage",
    "login_enter_key": "Entrez votre clé API",
    "login_api_key_required": "La clé API est obligatoire",
    "auth_required": "Authentification requise",
    "login_invalid_key": "Clé API invalide",
    "login_server_error": "Erreur serveur : {status}",
    "login_connection_failed": "Échec de connexion",
    "login_authenticating": "Authentification...",
    "login_button": "Connexion",
    "loading": "Chargement...",
    "save": "Enregistrer",
    "optional": "Optionnel",
    "enabled": "Activé",
    "disabled": "Désactivé",
    "status": "Statut",
    "connection": "Connexion",
    "auth": "Auth",
    "default": "défaut",
    "items_count": "{count} éléments",
    "history_title": "Historique",
    "history_subtitle": "Parcourir et inspecter les webhooks capturés",
    "history_refresh": "Rafraîchir",
    "history_refresh_title": "Rafraîchir la liste",
    "history_search_placeholder": "Rechercher un chemin... (Entrée)",
    "history_total": "{count} total",
    "history_sort_time": "Trier par heure",
    "history_sort_time_latest": "Plus récents d'abord (cliquer pour les plus anciens)",
    "history_sort_path": "Trier par chemin",
    "history_sort_path_asc": "A-Z (cliquer pour Z-A)",
    "history_sort_path_desc": "Z-A (cliquer pour A-Z)",
    "history_empty": "Aucun webhook reçu pour le moment",
    "history_rejected": "Rejeté",
    "history_rejected_title": "Rejeté avec HTTP {status}",
    "history_signature": "Sig",
    "history_signature_title": "Signature incluse",
    "history_from": "Depuis {ip} · {size} octets",
    "history_showing": "Affichage de {start} - {end} sur {total}",
    "history_detail": "Détail du webhook",
    "close": "Fermer",
    "live_title": "Direct",
    "live_subtitle": "Dernier webhook et en-têtes (mise à jour toutes les 1 s)",
    "live_paused": "En pause",
    "live_send_to": "Envoyez les webhooks vers :",
    "live_empty": "Aucun webhook reçu pour le moment",
    "live_show_more": "Voir plus",
    "live_show_less": "Voir moins",
    "live_waiting_title": "En attente de webhooks...",
    "live_waiting_body": "Envoyez une requête POST/PUT/PATCH/DELETE vers n'importe quel chemin de ce serveur",
    "live_received": "Reçu : {timestamp}",
    "live_from": "Depuis : {ip}",
    "live_origin": "Origine :",
    "live_bytes": "{size} octets",
    "live_multipart": "Téléversement de fichier (multipart) reçu - {size} octets. Corps brut ci-dessous.",
    "runtime_title": "Runtime",
    "runtime_subtitle": "Flux de logs en direct (rafraîchi toutes les 1 s)",
    "runtime_limit": "limite : {limit}",
    "runtime_updated": "mis à jour : {time}",
    "runtime_refresh_title": "Rafraîchir maintenant",
    "runtime_pause_title": "Mettre en pause",
    "runtime_resume_title": "Reprendre",
    "runtime_pause": "Pause",
    "runtime_search": "Recherche",
    "runtime_search_placeholder": "contient...",
    "runtime_search_hint": "Correspondance insensible à la casse.",
    "runtime_limit_label": "Limite",
    "runtime_limit_hint": "Plafond côté client (max 100).",
    "runtime_error_title": "Erreur du flux runtime",
    "runtime_last_lines": "Dernières {limit} lignes",
    "runtime_shown": "{count} affichées",
    "runtime_no_lines": "Aucune ligne.",
    "settings_title": "Paramètres",
    "settings_subtitle": "Configuration de cette instance",
    "settings_signature_title": "Vérification de signature",
    "settings_signature_hint": "Stocké dans Redis. Le type de signature est lu d'abord ; le backend l'utilise pour vérifier le secret. Le résultat est stocké par webhook (validé).",
    "settings_signature_header": "En-tête de signature (type)",
    "settings_secret_value": "Valeur du secret",
    "settings_rejection_title": "Rejet (échec forcé)",
    "settings_rejection_hint": "Quand activé, tous les webhooks entrants sont rejetés. Stocké dans Redis pour permettre un basculement en temps réel.",
    "settings_reject_all": "Rejeter tous les webhooks",
    "settings_status_code": "Code de statut",
    "reject_random": "Aléatoire - erreur aléatoire à chaque fois",
    "reject_cors": "simuler une erreur CORS",
    "http_400": "Bad Request",
    "http_401": "Unauthorized",
    "http_403": "Forbidden",
    "http_404": "simuler une URL inexistante",
    "http_405": "Method Not Allowed",
    "http_408": "Request Timeout",
    "http_409": "Conflict",
    "http_410": "Gone",
    "http_412": "Precondition Failed",
    "http_422": "Unprocessable Entity",
    "http_429": "Too Many Requests",
    "http_500": "Internal Server Error",
    "http_502": "Bad Gateway",
    "http_503": "simuler un mode maintenance",
    "http_504": "Gateway Timeout",
    "webhook_timestamp": "Horodatage",
    "webhook_source_ip": "IP source",
    "webhook_size": "Taille",
    "webhook_user_agent": "User Agent",
    "webhook_na": "N/D",
    "webhook_origin": "Origine",
    "webhook_response": "Réponse",
    "webhook_rejected_with": "Rejeté avec HTTP {status}",
    "webhook_config_at_process": "Config au moment du traitement",
    "webhook_reject": "Rejet :",
    "webhook_signing": "Signature :",
    "webhook_header": "en-tête",
    "webhook_secret": "secret :",
    "webhook_on": "activé ({status})",
    "webhook_off": "désactivé",
    "webhook_not_set_off": "non défini (désactivé)",
    "webhook_not_set": "non défini",
    "webhook_signature": "Signature",
    "webhook_no_signature": "Aucune signature reçue",
    "webhook_signing_not_configured": "Signature non configurée - définissez un secret dans Paramètres pour vérifier les signatures",
    "webhook_signature_valid": "Signature valide",
    "webhook_signature_invalid": "Signature invalide",
    "webhook_id": "ID",
    "login_acdev_headline": "allez plus vite avec baseblox",
    "login_acdev_description": "baseblox est une suite de microservices prets a integrer dans votre infrastructure pour reduire le temps de developpement des applications complexes et les couts de plateformes comme AWS.",
    "login_acdev_link": "acdevservices.com",
    "login_acdev_licensing": "licences & support",
    "login_acdev_contact": "support@acdevservices.com"
  },
  "es": {
    "lang_label": "Idioma",
    "app_name": "flytrap",
    "app_subtitle": "Capturador de webhooks para depuración",
    "menu": "Menú",
    "open_menu": "Abrir menú",
    "close_menu": "Cerrar menú",
    "connected": "Conectado",
    "disconnected": "Desconectado",
    "pause_polling": "Pausar sondeo",
    "resume_polling": "Reanudar sondeo",
    "refresh": "Actualizar",
    "nav_live": "En vivo",
    "nav_history": "Historial",
    "nav_settings": "Configuración",
    "nav_runtime": "Runtime",
    "logout": "Cerrar sesión",
    "api_key": "Clave API",
    "login_subtitle": "Capturador de webhooks para depuración",
    "login_enter_key": "Ingresa tu clave API",
    "login_api_key_required": "La clave API es obligatoria",
    "auth_required": "Autenticación obligatoria",
    "login_invalid_key": "Clave API inválida",
    "login_server_error": "Error del servidor: {status}",
    "login_connection_failed": "Error de conexión",
    "login_authenticating": "Autenticando...",
    "login_button": "Ingresar",
    "loading": "Cargando...",
    "save": "Guardar",
    "optional": "Opcional",
    "enabled": "Activado",
    "disabled": "Desactivado",
    "status": "Estado",
    "connection": "Conexión",
    "auth": "Auth",
    "default": "predeterminado",
    "items_count": "{count} elementos",
    "history_title": "Historial",
    "history_subtitle": "Explora e inspecciona los webhooks capturados",
    "history_refresh": "Actualizar",
    "history_refresh_title": "Actualizar lista",
    "history_search_placeholder": "Buscar ruta... (Enter)",
    "history_total": "{count} total",
    "history_sort_time": "Ordenar por hora",
    "history_sort_time_latest": "Más recientes primero (clic para más antiguos)",
    "history_sort_path": "Ordenar por ruta",
    "history_sort_path_asc": "A-Z (clic para Z-A)",
    "history_sort_path_desc": "Z-A (clic para A-Z)",
    "history_empty": "Aún no se recibieron webhooks",
    "history_rejected": "Rechazado",
    "history_rejected_title": "Rechazado con HTTP {status}",
    "history_signature": "Sig",
    "history_signature_title": "Firma incluida",
    "history_from": "Desde {ip} · {size} bytes",
    "history_showing": "Mostrando {start} - {end} de {total}",
    "history_detail": "Detalle del webhook",
    "close": "Cerrar",
    "live_title": "En vivo",
    "live_subtitle": "Último webhook y encabezados (actualiza cada 1 s)",
    "live_paused": "Pausado",
    "live_send_to": "Envía webhooks a:",
    "live_empty": "Aún no se recibió ningún webhook",
    "live_show_more": "Ver más",
    "live_show_less": "Ver menos",
    "live_waiting_title": "Esperando webhooks...",
    "live_waiting_body": "Envía una solicitud POST/PUT/PATCH/DELETE a cualquier ruta en este servidor",
    "live_received": "Recibido: {timestamp}",
    "live_from": "Desde: {ip}",
    "live_origin": "Origen:",
    "live_bytes": "{size} bytes",
    "live_multipart": "Se recibió una carga de archivo (multipart) - {size} bytes. Cuerpo sin procesar abajo.",
    "runtime_title": "Runtime",
    "runtime_subtitle": "Cola de logs en vivo (se actualiza cada 1 s)",
    "runtime_limit": "límite: {limit}",
    "runtime_updated": "actualizado: {time}",
    "runtime_refresh_title": "Actualizar ahora",
    "runtime_pause_title": "Pausar sondeo",
    "runtime_resume_title": "Reanudar sondeo",
    "runtime_pause": "Pausa",
    "runtime_search": "Buscar",
    "runtime_search_placeholder": "contiene...",
    "runtime_search_hint": "Coincidencia sin distinguir mayúsculas.",
    "runtime_limit_label": "Límite",
    "runtime_limit_hint": "Tope del cliente (máx. 100).",
    "runtime_error_title": "Error de cola runtime",
    "runtime_last_lines": "Últimas {limit} líneas",
    "runtime_shown": "{count} mostradas",
    "runtime_no_lines": "Sin líneas.",
    "settings_title": "Configuración",
    "settings_subtitle": "Cómo está configurada esta instancia",
    "settings_signature_title": "Verificación de firma",
    "settings_signature_hint": "Se almacena en Redis. Primero se lee el tipo de firma; el backend lo usa para verificar el secreto. El resultado se guarda por webhook (validado).",
    "settings_signature_header": "Encabezado de firma (tipo)",
    "settings_secret_value": "Valor del secreto",
    "settings_rejection_title": "Rechazo (fallar siempre)",
    "settings_rejection_hint": "Cuando está activado, todos los webhooks entrantes se rechazan. Se almacena en Redis para poder alternarlo en tiempo real.",
    "settings_reject_all": "Rechazar todos los webhooks",
    "settings_status_code": "Código de estado",
    "reject_random": "Aleatorio - error aleatorio cada vez",
    "reject_cors": "simular error CORS",
    "http_400": "Bad Request",
    "http_401": "Unauthorized",
    "http_403": "Forbidden",
    "http_404": "simular URL inexistente",
    "http_405": "Method Not Allowed",
    "http_408": "Request Timeout",
    "http_409": "Conflict",
    "http_410": "Gone",
    "http_412": "Precondition Failed",
    "http_422": "Unprocessable Entity",
    "http_429": "Too Many Requests",
    "http_500": "Internal Server Error",
    "http_502": "Bad Gateway",
    "http_503": "simular modo mantenimiento",
    "http_504": "Gateway Timeout",
    "webhook_timestamp": "Marca de tiempo",
    "webhook_source_ip": "IP de origen",
    "webhook_size": "Tamaño",
    "webhook_user_agent": "User Agent",
    "webhook_na": "N/D",
    "webhook_origin": "Origen",
    "webhook_response": "Respuesta",
    "webhook_rejected_with": "Rechazado con HTTP {status}",
    "webhook_config_at_process": "Config al momento del proceso",
    "webhook_reject": "Rechazo:",
    "webhook_signing": "Firma:",
    "webhook_header": "encabezado",
    "webhook_secret": "secreto:",
    "webhook_on": "activo ({status})",
    "webhook_off": "apagado",
    "webhook_not_set_off": "no configurado (apagado)",
    "webhook_not_set": "no configurado",
    "webhook_signature": "Firma",
    "webhook_no_signature": "No se recibió firma",
    "webhook_signing_not_configured": "Firma no configurada - define un secreto en Configuración para verificar firmas",
    "webhook_signature_valid": "Firma válida",
    "webhook_signature_invalid": "Firma inválida",
    "webhook_id": "ID",
    "login_acdev_headline": "lanza mas rapido con baseblox",
    "login_acdev_description": "baseblox es una suite de microservicios lista para integrarse en tu infraestructura y reducir tanto el tiempo necesario para crear aplicaciones complejas como los costes de plataformas como AWS.",
    "login_acdev_link": "acdevservices.com",
    "login_acdev_licensing": "licencias y soporte",
    "login_acdev_contact": "support@acdevservices.com"
  },
  "pt": {
    "lang_label": "Idioma",
    "app_name": "flytrap",
    "app_subtitle": "Capturador de webhooks para depuração",
    "menu": "Menu",
    "open_menu": "Abrir menu",
    "close_menu": "Fechar menu",
    "connected": "Conectado",
    "disconnected": "Desconectado",
    "pause_polling": "Pausar polling",
    "resume_polling": "Retomar polling",
    "refresh": "Atualizar",
    "nav_live": "Ao vivo",
    "nav_history": "Histórico",
    "nav_settings": "Configurações",
    "nav_runtime": "Runtime",
    "logout": "Sair",
    "api_key": "Chave API",
    "login_subtitle": "Capturador de webhooks para depuração",
    "login_enter_key": "Digite sua chave de API",
    "login_api_key_required": "A chave de API é obrigatória",
    "auth_required": "Autenticacao obrigatoria",
    "login_invalid_key": "Chave de API inválida",
    "login_server_error": "Erro do servidor: {status}",
    "login_connection_failed": "Falha de conexão",
    "login_authenticating": "Autenticando...",
    "login_button": "Entrar",
    "loading": "Carregando...",
    "save": "Salvar",
    "optional": "Opcional",
    "enabled": "Ativado",
    "disabled": "Desativado",
    "status": "Status",
    "connection": "Conexão",
    "auth": "Auth",
    "default": "padrao",
    "items_count": "{count} itens",
    "history_title": "Historico",
    "history_subtitle": "Navegue e inspecione os webhooks capturados",
    "history_refresh": "Atualizar",
    "history_refresh_title": "Atualizar lista",
    "history_search_placeholder": "Buscar rota... (Enter)",
    "history_total": "{count} total",
    "history_sort_time": "Ordenar por hora",
    "history_sort_time_latest": "Mais recentes primeiro (clique para mais antigos)",
    "history_sort_path": "Ordenar por rota",
    "history_sort_path_asc": "A-Z (clique para Z-A)",
    "history_sort_path_desc": "Z-A (clique para A-Z)",
    "history_empty": "Nenhum webhook recebido ainda",
    "history_rejected": "Rejeitado",
    "history_rejected_title": "Rejeitado com HTTP {status}",
    "history_signature": "Sig",
    "history_signature_title": "Assinatura incluida",
    "history_from": "De {ip} · {size} bytes",
    "history_showing": "Mostrando {start} - {end} de {total}",
    "history_detail": "Detalhe do webhook",
    "close": "Fechar",
    "live_title": "Ao vivo",
    "live_subtitle": "Ultimo webhook e cabecalhos (atualiza a cada 1 s)",
    "live_paused": "Pausado",
    "live_send_to": "Envie webhooks para:",
    "live_empty": "Nenhum webhook recebido ainda",
    "live_show_more": "Mostrar mais",
    "live_show_less": "Mostrar menos",
    "live_waiting_title": "Aguardando webhooks...",
    "live_waiting_body": "Envie uma requisicao POST/PUT/PATCH/DELETE para qualquer rota neste servidor",
    "live_received": "Recebido: {timestamp}",
    "live_from": "De: {ip}",
    "live_origin": "Origem:",
    "live_bytes": "{size} bytes",
    "live_multipart": "Upload de arquivo (multipart) recebido - {size} bytes. Corpo bruto abaixo.",
    "runtime_title": "Runtime",
    "runtime_subtitle": "Cauda de logs ao vivo (atualiza a cada 1 s)",
    "runtime_limit": "limite: {limit}",
    "runtime_updated": "atualizado: {time}",
    "runtime_refresh_title": "Atualizar agora",
    "runtime_pause_title": "Pausar polling",
    "runtime_resume_title": "Retomar polling",
    "runtime_pause": "Pausa",
    "runtime_search": "Buscar",
    "runtime_search_placeholder": "contem...",
    "runtime_search_hint": "Correspondencia sem diferenciar maiusculas.",
    "runtime_limit_label": "Limite",
    "runtime_limit_hint": "Limite do cliente (max 100).",
    "runtime_error_title": "Erro da cauda runtime",
    "runtime_last_lines": "Ultimas {limit} linhas",
    "runtime_shown": "{count} exibidas",
    "runtime_no_lines": "Sem linhas.",
    "settings_title": "Configuracoes",
    "settings_subtitle": "Como esta instancia esta configurada",
    "settings_signature_title": "Verificacao de assinatura",
    "settings_signature_hint": "Armazenado no Redis. O tipo da assinatura e lido primeiro; o backend usa isso para verificar o segredo. O resultado fica salvo por webhook (validado).",
    "settings_signature_header": "Cabecalho de assinatura (tipo)",
    "settings_secret_value": "Valor do segredo",
    "settings_rejection_title": "Rejeicao (falhar sempre)",
    "settings_rejection_hint": "Quando ligado, todos os webhooks recebidos sao rejeitados. Armazenado no Redis para alternar em tempo real.",
    "settings_reject_all": "Rejeitar todos os webhooks",
    "settings_status_code": "Codigo de status",
    "reject_random": "Aleatorio - erro aleatorio a cada vez",
    "reject_cors": "simular erro CORS",
    "http_400": "Bad Request",
    "http_401": "Unauthorized",
    "http_403": "Forbidden",
    "http_404": "simular URL inexistente",
    "http_405": "Method Not Allowed",
    "http_408": "Request Timeout",
    "http_409": "Conflict",
    "http_410": "Gone",
    "http_412": "Precondition Failed",
    "http_422": "Unprocessable Entity",
    "http_429": "Too Many Requests",
    "http_500": "Internal Server Error",
    "http_502": "Bad Gateway",
    "http_503": "simular modo de manutencao",
    "http_504": "Gateway Timeout",
    "webhook_timestamp": "Horario",
    "webhook_source_ip": "IP de origem",
    "webhook_size": "Tamanho",
    "webhook_user_agent": "User Agent",
    "webhook_na": "N/D",
    "webhook_origin": "Origem",
    "webhook_response": "Resposta",
    "webhook_rejected_with": "Rejeitado com HTTP {status}",
    "webhook_config_at_process": "Config no momento do processamento",
    "webhook_reject": "Rejeicao:",
    "webhook_signing": "Assinatura:",
    "webhook_header": "cabecalho",
    "webhook_secret": "segredo:",
    "webhook_on": "ligado ({status})",
    "webhook_off": "desligado",
    "webhook_not_set_off": "nao definido (desligado)",
    "webhook_not_set": "nao definido",
    "webhook_signature": "Assinatura",
    "webhook_no_signature": "Nenhuma assinatura recebida",
    "webhook_signing_not_configured": "Assinatura nao configurada - defina um segredo em Configuracoes para verificar assinaturas",
    "webhook_signature_valid": "Assinatura valida",
    "webhook_signature_invalid": "Assinatura invalida",
    "webhook_id": "ID",
    "login_acdev_headline": "entregue mais rapido com baseblox",
    "login_acdev_description": "baseblox e uma suite de microsservicos pronta para entrar na sua infraestrutura e reduzir tanto o tempo de criacao de aplicacoes complexas quanto os custos de plataformas como a AWS.",
    "login_acdev_link": "acdevservices.com",
    "login_acdev_licensing": "licenciamento e suporte",
    "login_acdev_contact": "support@acdevservices.com"
  }
};

export function t(locale, key, params = {}) {
  let value = dictionary[locale]?.[key] ?? dictionary.en[key] ?? key;
  Object.entries(params).forEach(([k, v]) => {
    value = value.replaceAll(`{${k}}`, String(v));
  });
  return value;
}
